import * as React from 'react'
/**
 * @param {HeroProgressProps} HeroProgressProps - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const HeroProgress = ({
  autoScrolling,
  invertTextColor,
  totalItemCount,
  activeItemIndex
}) => {
  return (
    <div
      aria-hidden="true"
      className={`hero-progress ${
        invertTextColor ? 'hero-progress--dark' : ''
      }`}
    >
      {Array.from({ length: totalItemCount }).map((_, index) => (
        <div
          key={`hero-progress-${index}`}
          className={`hero-progress__step ${
            index === activeItemIndex ? 'hero-progress__step--active' : ''
          }`}
        >
          <div
            className={`hero-progress__step-inner ${
              autoScrolling ? `hero-progress__step-inner--auto-scrolling` : ''
            }`}
          ></div>
        </div>
      ))}
    </div>
  )
}

export default HeroProgress

/**
 * @typedef {{
 * autoScrolling: boolean,
 * invertTextColor: boolean,
 * totalItemCount: number,
 * activeItemIndex: number
 * }} HeroProgressProps
 */
